module.exports = __webpack_public_path__ + "media/images/dish-18b0757ba64e1bdf4ad3e9a2216a13a2.jpg";